import styled from '@emotion/styled';
import { Button } from '@mui/material';
import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';

// eslint-disable-next-line react-refresh/only-export-components
export const BreadcrumbWrapper = styled('div')({
  height: 36,
  display: 'flex',
  alignItems: 'center',
});

// eslint-disable-next-line react-refresh/only-export-components
export const StyledBreadcrumb = styled(Button)({
  textTransform: 'none',
  font: 'inherit',
});

const StyledActiveFolderBreadcrumb = styled(
  StyledBreadcrumb.withComponent('span'),
)({
  paddingLeft: 8,
  fontWeight: 700,
});

type FolderBreadcrumbProps = {
  folderName: string;
  onCloseChildFolders: () => void;
  isActiveFolder: boolean;
};

const FolderBreadcrumb = ({
  folderName,
  onCloseChildFolders,
  isActiveFolder,
}: FolderBreadcrumbProps) => {
  if (isActiveFolder) {
    return (
      <BreadcrumbWrapper>
        <StyledActiveFolderBreadcrumb>
          {folderName}
        </StyledActiveFolderBreadcrumb>
      </BreadcrumbWrapper>
    );
  }

  return (
    <BreadcrumbWrapper>
      <StyledBreadcrumb color="secondary" onClick={onCloseChildFolders}>
        {folderName}
      </StyledBreadcrumb>
      <ChevronRightIcon />
    </BreadcrumbWrapper>
  );
};

export default FolderBreadcrumb;
